module.exports = __webpack_public_path__ + "static/media/github.f5a069d2.svg";